module.exports = __webpack_public_path__ + "img/Wachtwoord5FA7C4.0241f2fd.png";